import { AppActions } from 'app/appSlice'
import { isUndefined } from 'lodash'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const useActions = (callback, dependencies = []) => {
    const dispatch = useDispatch()

    useEffect(() => {
        const actions = callback()
        const filteredActions = actions.filter(a => a.displayed || isUndefined(a.displayed))
        dispatch(AppActions.actions(filteredActions))
    }, dependencies)

    useEffect(() => { // clean actions
        return () => dispatch(AppActions.actions([]))
    }, [])
}

export default useActions